import React, { useState, useEffect, useContext } from "react";
import { FormatCreditCard } from "../../containers/common/functions";
import AxioInstance from "../../axios/AxiosConfig";
import { useHistory } from 'react-router-dom';
import moment from "moment/moment";
import { IoMdLock, IoMdUnlock, IoMdEyeOff, IoMdEye } from "react-icons/io";

import { FaPlus } from "react-icons/fa";
import { CircularProgress } from "@material-ui/core";
import { ModalPassword } from "../modals/ModalPassword";
import { AuthContext } from "../../context/AuthContext";
import { MdShoppingCart } from "react-icons/md";

const DetailCardPage = (props) => {
    const state = props.location.state;/* {
        "balance": "125.00",
        "cvv": "041",
        "display_expiration": "01/25",
        "id": "d18af916-b8df-4f87-8b88-fdf746fba031",
        "masked_pan": "4513650002543696",
        "max_balance": "125.00",
        "state": "ACTIVE",
        "support_token": "0f990babfb"
    } */

    const [showDetailsCard, setShowDetailsCard] = useState(false);
    const [loadingShowDetails, setLoadingShowDetails] = useState(false);
    const [movements, setMovements] = useState([]);
    const [refreshing, setRefreshing] = useState(false);
    const [promptVisible, setPromptVisible] = useState(false);

    const [balance, setBalance] = useState(0); // Ejemplo
    const [cardNumber, setCardNumber] = useState(state?.masked_pan); // Ejemplo 
    const [ExpDate, setExpDate] = useState(""); // Ejemplo
    const [cvc, setCvc] = useState(""); // Ejemplo
    const ITEMS_PER_PAGE = 10;
    const [currentPage, setCurrentPage] = useState(1);
    const [hasMoreMovements, setHasMoreMovements] = useState(false);
    const [isActiveCard, setIsActiveCard] = useState(state.state === 'ACTIVE' ? true : false)

    const [showModalPassword, setShowModalPassword] = useState(false);
    const [error, setError] = useState(false);

    const { getAuthenticatedHeaders, userDetailsContext } = useContext(AuthContext);

    const [loadingMovements, setLoadingMovements] = useState(false);

    const handleRefresh = () => {
        setRefreshing(true);
        // Lógica para refrescar datos
        setRefreshing(false);
    };

    const fetchMovements = async () => {
        setLoadingMovements(true);
        try {
            const response = await AxioInstance.post('/api/get_card_movements', {
                card_id: state?.id || state.card_id,
                per_page: ITEMS_PER_PAGE,
                page_num: currentPage,
                headers: await getAuthenticatedHeaders(),
            });
            console.log("🚀 ~ fetchMovements ~ response:", response)
            if (response.data?.status === 200) {
                const newMovements = response.data?.data?.result?.transactions || [];
                setMovements((prevMovements) => [...prevMovements, ...newMovements]);
                setHasMoreMovements(newMovements.length === ITEMS_PER_PAGE);
            } else {
                console.log('Ups! Ha ocurrido un error al cargar los movimientos');
            }
        } catch (error) {
            console.error('Error al obtener movimientos:', error);
        } finally {
            setLoadingMovements(false);
        }
    };

    const loadMoreMovements = () => {
        setCurrentPage((prevPage) => prevPage + 1);
    };

    // Llama a fetchMovements cuando el componente se monte o currentPage cambie
    useEffect(() => {
        fetchMovements();
    }, [currentPage]);

    const getDetailsCard = async () => {
        if (!isActiveCard) return
        setShowModalPassword(false)
        try {

            const response = await AxioInstance.post('/api/get_card', {
                card_id: state?.id || state?.card_id,
                headers: await getAuthenticatedHeaders(),

            })
            const cardDetails = response.data?.data?.result
            if (response.data?.status !== 200) {
                alert('Ups! Ha ocurrido un error')
                setLoadingShowDetails(false)
            } else {
                setCvc(cardDetails?.cvv)
                setExpDate(cardDetails?.display_expiration)
                setBalance(cardDetails?.available_balance)
                setCardNumber(cardDetails.masked_pan)
                setIsActiveCard(cardDetails?.state === 'ACTIVE' ? true : false)

                setShowDetailsCard(true)
                setLoadingShowDetails(false)
            }

        } catch (error) {
            console.error(error)
            setLoadingShowDetails(false)
            setShowModalPassword(false)

        }
    }
    const changeStateFreezeCard = async (stateFreeze = false) => {
        setLoadingShowDetails(true)
        const response = await AxioInstance.post('/api/freeze_card', {
            card_id: state?.id || state?.card_id,
            freeze: stateFreeze,
            headers: await getAuthenticatedHeaders(),
        })
        /*         const response = await API.POST.FreezeCard({ card_id: route.params?.card_id || route?.params?.id, freeze: stateFreeze })
         */
        console.log("🚀 ~ changeStateFreezeCard ~ response:", response)
        if (response.data?.status === true) {
            alert('Ups!', 'Ah ocurrido un error')
            setLoadingShowDetails(false)
        } else {
            setIsActiveCard(!stateFreeze)
            /*     setCvc(cardDetails?.cvv)
                setExpDate(cardDetails?.display_expiration)
                setBalance(cardDetails?.available_balance)
                setCardNumber(cardDetails.masked_pan)
                setShowDetailsCard(true)
                setLoadingShowDetails(false) */
        }
        setLoadingShowDetails(false)

    }
    const history = useHistory();
    const formatDate = (datetime) => {
        let date = moment(datetime);

        // Calcular los días desde la fecha
        let daysSince = moment().diff(date, 'days');

        if (daysSince === 0) {
            // Formatear la hora en formato local sin zona horaria
            date = date.format('LT'); // Esto ya usa la hora local del dispositivo
        } else if (daysSince === 1) {
            date = "ayer";
        } else if (daysSince > 3) {
            date = date.format('DD/MM/YYYY'); // Formato de fecha (día/mes/año)
        } else {
            date = `hace ${daysSince} día${daysSince > 1 ? 's' : ''}`;
        }
        return date;
    }
    const changeBgColor = (state) => {
        let color = "";
        let line = false;
        let textStatus = "";

        switch (state) {
            case 'SETTLED':
                color = 'bg-green-600';
                textStatus = 'SETTLED';
                break;
            case 'PENDING':
                color = 'bg-yellow-500';
                textStatus = 'PENDING';
                break;
            default:
                color = 'Color-red'
                break;
        }
        return { color, line, textStatus };
    };
    const checkUserPassword = async (password) => {
        getDetailsCard()

    };
    if (!state?.id && !state?.card_id) {
        history.goBack();
        return null;
    }
    return (
        <>
            {
                showModalPassword && (
                    <ModalPassword
                        handleOK={checkUserPassword}
                        handleCancel={() => {
                            setShowModalPassword(false)
                            setLoadingShowDetails(false)
                        }}
                        error={error}
                    />
                )
            }

            <div className="flex flex-col min-h-screen">
                <div className="mx-auto w-full">
                    <div className="flex flex-col items-center py-4 shadow-md">

                        <div className="text-center">
                            <p className="text-sm text-gray-500">Disponible</p>
                            <p className="text-lg font-bold text-gray-800">
                                {showDetailsCard ? `$${balance} USD` : "••••"}
                            </p>
                        </div>
                        {/* <div className="p-4 flex justify-end item</div></div>s-center">
                        <button onClick={() => { }} className="text-gray-600">
                            Listado
                        </button>
                    </div> */}
                    </div>

                    <div className="p-6">
                        <div className="bg-white max-w-sm mx-auto rounded-lg shadow-lg p-4 h-48 sm:h-56 flex flex-col justify-between ">
                            <div className="flex justify-between items-start">
                                <img
                                    src={require('../../assets/card/cobruVertical.png')}
                                    alt="Logo"
                                    className="w-10 h-16 object-contain"
                                />
                                <div className="flex space-x-4">


                                    <button
                                        disabled={loadingShowDetails || !isActiveCard}
                                        className={`flex flex-col items-center ${!isActiveCard ? 'opacity-50' : ''}`}
                                        onClick={() => {
                                            if (showDetailsCard) {
                                                setShowDetailsCard(false);
                                                setLoadingShowDetails(false);
                                            } else {
                                                setLoadingShowDetails(true);
                                                setShowModalPassword(true);
                                                // Autenticación biométrica
                                            }
                                        }}
                                    >
                                        <div className="border border-gray-300 rounded-full p-2 w-10 h-10 flex items-center justify-center">
                                            {loadingShowDetails ? (
                                                <CircularProgress size={20} />
                                            ) : showDetailsCard ? (
                                                <IoMdEyeOff size="1.5em" />

                                            ) : (
                                                <IoMdEye size="1.5em" />

                                            )}
                                        </div>
                                        <p style={{ margin: '0px' }} className="text-xs text-center text-gray-500">
                                            {showDetailsCard ? "Ocultar" : "Ver"}
                                        </p>
                                    </button>
                                    <button
                                        disabled={loadingShowDetails || !isActiveCard}
                                        className={`flex flex-col items-center ${!isActiveCard ? 'opacity-50' : ''}`} onClick={() => {
                                            if (!isActiveCard) return

                                            history.push('/tarjetas/recargar', { card: state })
                                        }}>
                                        <div className="border border-gray-300 rounded-full p-2 w-10 h-10 flex items-center justify-center">
                                            <FaPlus size="1em" />
                                        </div>
                                        <p className="text-xs text-gray-500">Recargar</p>
                                    </button>
                                    <button
                                        disabled={loadingShowDetails}
                                        className="flex flex-col items-center"
                                        onClick={() => {
                                            changeStateFreezeCard(isActiveCard)
                                        }}
                                    >
                                        <div className="border border-gray-300 rounded-full p-2 w-10 h-10 flex items-center justify-center">
                                            {isActiveCard ? <IoMdLock size="1.5em" /> : <IoMdUnlock size="1.5em" />}
                                        </div>
                                        <p style={{ margin: '0px' }} className="text-xs text-center text-gray-500">
                                            {isActiveCard ? 'Congelar' : 'Descongelar'}
                                        </p>
                                    </button>
                                </div>
                            </div>

                            <div className="mt-4">
                                <div className="flex justify-between">

                                    <p className="text-base">{state?.card_name}</p>

                                </div>
                                {showDetailsCard && (
                                    <div className="flex space-x-8" d>
                                        <div>
                                            <p className="text-xs text-gray-500">MES/AÑO</p>
                                            <p className="text-base">{ExpDate}</p>
                                        </div>
                                        <div>
                                            <p className="text-xs text-gray-500">CVC</p>
                                            <p className="text-base">{cvc}</p>
                                        </div>
                                    </div>
                                )}
                                <div className="flex justify-between mt-4">

                                    <p
                                        className={`text-lg ${!isActiveCard ? 'opacity-50 line-through' : ''}`}
                                    >{FormatCreditCard(cardNumber, !showDetailsCard)}</p>
                                    <img
                                        src={require('../../assets/card/VISA.png')}
                                        alt="Visa"
                                        className="w-12 object-contain"
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="mt-6">
                            {loadingMovements && <p className="text-center text-gray-500">Cargando...</p>}
                            {movements.length > 0 ? (
                                movements.map((item, index) => (
                                    <div
                                        key={index}
                                        className="flex items-center justify-center bg-white p-4 rounded-lg shadow-md mb-4"
                                    >
                                        <div className="rounded-full bg-gray-200 w-10 h-10 flex items-center justify-center mr-3">
                                            <MdShoppingCart color="#02579f" />
                                        </div>

                                        <div className="flex flex-col w-full">

                                            <div className="flex flex-row items-center justify-between w-full">
                                                <div className="flex flex-row items-center w-full">
                                                    <p style={{ marginLeft: 0 }} className={`text-base text-gray-800 font-bold ${changeBgColor(item?.transaction_status).line ? 'line-through' : ''}`}>${parseFloat(item?.amount).toFixed(2)}</p>
                                                    {item?.fee && (
                                                        <p style={{ marginLeft: 4 }} className="text-sm text-gray-400">
                                                            {item?.fee && !isNaN(item.fee) ? `(+${parseFloat(item.fee).toFixed(2)} comisión)` : ''}
                                                        </p>)}
                                                </div>
                                                <p className="text-xs text-gray-400">{formatDate(item.datetime)}</p>
                                            </div>
                                            <div className="flex flex-row items-center">
                                                <div title={changeBgColor(item?.transaction_status).textStatus} className={`rounded-full ${changeBgColor(item?.transaction_status).color} w-3 h-3 flex items-center justify-center`} />
                                                <p style={{ marginLeft: 7 }} className="text-xs text-gray-500">{item.merchant}</p>
                                            </div>
                                        </div>

                                    </div>
                                ))
                            ) : (
                                loadingMovements ?
                                    null
                                    :
                                    <p className="text-center text-gray-500">No hay movimientos</p>
                            )}
                            {hasMoreMovements && !loadingMovements && (
                                <button
                                    onClick={loadMoreMovements}
                                    className="text-center text-blue-500 mt-4"
                                >
                                    Cargar más movimientos
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
};

export default DetailCardPage;
